import React from 'react';
import styled from 'styled-components';
import { MoneyBagLinear, IdeaVector, DiscoverIcon, StartupScore } from 'src/assets/images';

const WorldNeedsSection: React.FC = () => {
  return (
    <Container>
      <SubTitle>Startup Focused Platform</SubTitle>
      <SubDescription>
        Build and scale your startup with our global startup ecosystem
      </SubDescription>
      
      <FeaturesGrid>
        <FeatureCard>
          <FeatureIcon><img src={ StartupScore } alt="Rocket Icon" style={{ width: '60px' }}/></FeatureIcon>
          <FeatureTitle>Score</FeatureTitle>
          <FeatureDescription>
            Evaluate your startup against 1000+ ways an investor assesses
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <FeatureIcon><img src={ MoneyBagLinear } alt="Rocket Icon" style={{ width: '60px' }}/></FeatureIcon>
          <FeatureTitle>Funding</FeatureTitle>
          <FeatureDescription>
            No more spray and pray. Targeted & Focused
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <FeatureIcon><img src={ DiscoverIcon } alt="Rocket Icon" style={{ width: '60px' }}/></FeatureIcon>
          <FeatureTitle>Discover</FeatureTitle>
          <FeatureDescription>
            Right incubator & accelerator program for your startup
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <FeatureIcon><img src={ IdeaVector } alt="Rocket Icon" style={{ width: '60px' }}/></FeatureIcon>
          <FeatureTitle>Idea Hub</FeatureTitle>
          <FeatureDescription>
            For aspiring & very early-stage startups
          </FeatureDescription>
        </FeatureCard>
      </FeaturesGrid>
    </Container>
  );
};

const Container = styled.section`
  padding: 80px 60px;
  background-color: #fafafa;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 24px;
  
  span {
    color: #FF4B26;
  }
`;

const Description = styled.p`
  font-size: 18px;
  color: #666;
  max-width: 600px;
  margin: 0 auto 60px;
`;

const SubTitle = styled.h3`
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 16px;
   background: linear-gradient(90deg, #FF5733, #FF8C00);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const SubDescription = styled.p`
  font-size: 18px;
  color: #666;
  margin-bottom: 48px;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`

  padding: 24px;
  transition: transform 0.3s ease;
  /* background:linear-gradient(0deg, rgb(255, 255, 255), rgb(255 157 133 / 14%)); */
  background: #ffffff;
  box-shadow: 0 0px 40px rgba(162, 42, 1, 0.1);
  border-radius: 16px;
  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
  flex: 1;
  max-width: 400px;
  border: 0.5px solid rgba(255, 91, 36, 0.3);

  &:hover {
    border-color: #ff5924;
    box-shadow: 0 25px 60px rgba(255, 89, 36, 0.15);
    transform: translateY(-4px);

  }
`;

const FeatureIcon = styled.div`
  font-size: 36px;
  margin-bottom: 16px;
`;

const FeatureTitle = styled.h4`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
`;

const FeatureDescription = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
`;

export default WorldNeedsSection;
